import type { PublicationDataDtoV1 } from '@/api/kubik/infoportal'

export const sortArraysByDate = (array: PublicationDataDtoV1[]) =>
  array.slice().sort((a, b) => Date.parse(b.publicationDate || '0') - Date.parse(a.publicationDate || '0'))
